import type { TimbaStanding } from '../api/client';

// Lógica pura del puesto en el ranking de la Timba. Módulo hoja (solo `import type`) → testeable
// con node sin arrastrar el resto de la app (ver tools/timba_rank_test.mjs).

export interface RankedStanding extends TimbaStanding {
  position: number; // puesto DENSO: mismo puntaje = mismo puesto, el siguiente distinto es +1 (1, 1, 2)
}

// Asigna el PUESTO por puntaje (mismo puntaje = mismo puesto) sobre standings ya ordenados por el
// backend (puntos desc, exactos desc) y, dentro del puesto del usuario logueado, lo pone PRIMERO
// para que se vea al frente de su grupo. Función pura (no muta la entrada).
//
// Puesto DENSO (no de competición): si 8 quedan en el puesto 4, el siguiente puntaje es el puesto 5
// (no el 12). Así los puestos no saltan cuando mucha gente comparte puntaje (típico en el prode).
export function rankStandings(standings: TimbaStanding[], myPub: string): RankedStanding[] {
  const ranked: RankedStanding[] = [];
  let position = 0;
  for (let i = 0; i < standings.length; i++) {
    const s = standings[i];
    const samePoints = i > 0 && standings[i - 1].points === s.points;
    if (!samePoints) position++;
    ranked.push({ ...s, position });
  }
  const meIdx = ranked.findIndex((r) => r.pub === myPub);
  if (meIdx > 0) {
    const groupStart = ranked.findIndex((r) => r.position === ranked[meIdx].position);
    if (groupStart < meIdx) {
      const [me] = ranked.splice(meIdx, 1);
      ranked.splice(groupStart, 0, me);
    }
  }
  return ranked;
}
